import { UseFormatMessageResult, MessageType } from './model';
import { translate } from './utils';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const useFormatMessage = (
  formatMessage: any
): UseFormatMessageResult => {
  const translateMessage = (message: MessageType): string => {
    const outputMessage = translate(message, formatMessage);
    Logger.info(
      ['translateMessage', message, outputMessage],
      LogArea.Localization
    );
    return outputMessage;
  };
  return { translate: translateMessage };
};

export default useFormatMessage;
